export const textTruncate = (text: string, maxlength: number) => {
  if (text.length <= maxlength) {
    return text;
  } else {
    return text.substring(0, maxlength) + "...";
  }
};
